// Order.js
// Redux Container for Order View

// Imports
import { connect } from 'react-redux';
import * as Action from '../actions/order';
import OrderView from '../components/OrderView/';

// State Mapper
const mapStateToProps = state => ({
  products: state.product,
  clients: state.client,
  orders: state.order,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
  setOrderProduct: (cId, pId, uId, quantity, customPrice = undefined) => dispatch(Action.setOrderProduct(cId, pId, uId, quantity, customPrice)),
  setOrderAdjustment: (cId, value, description = undefined) => dispatch(Action.setOrderAdjustment(cId, value, description)),
})

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(OrderView);


// WEBPACK FOOTER //
// ./src/containers/Order.js